// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-bundle.js?" + {"vendors-node_modules_vanilla-picker_dist_vanilla-picker_mjs":"274133a10fe88669afce","bower_components_chart_js_dist_Chart_js":"e1f29409c1ae240c52b7"}[chunkId] + "";
};